import { COLOR, FONT_SIZE, FONT_WEIGHT, Icon, mq } from "@dmm-com/rocket-web-ui-library";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const DivRootFlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: inherit;
  width: 100%;
`;

export const DivWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const IconHeading = styled(Icon)<{ isBlockDetailHeader: boolean }>`
  & svg {
    width: 156px;
    height: 136px;
  }
  ${mq.sp} {
    ${({ isBlockDetailHeader }) =>
      isBlockDetailHeader
        ? css`
            display: none;
          `
        : css`
            & svg {
              width: 97.5px;
              height: 85px;
            }
          `}
  }
`;

export const DivDescriptionWrapper = styled.div`
  text-align: center;
  margin-bottom: 32px;
  ${mq.sp} {
    margin-bottom: 16px;
  }
`;

export const DivHeading = styled.div`
  font-size: 40px;
  font-weight: ${FONT_WEIGHT.BOLD};
  color: ${COLOR.GRAY500.code};
  ${mq.sp} {
    font-size: 20px;
  }
`;

export const DivDescription = styled.div`
  color: ${COLOR.GRAY500.code};
  font-size: ${FONT_SIZE.M}px;
  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const DivButtonDescription = styled.div<{ isBlockDetailHeader: boolean }>`
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  width: 100%;
  padding: 0 16px;

  ${mq.sp} {
    font-size: ${FONT_SIZE.S}px;
    ${({ isBlockDetailHeader }) =>
      isBlockDetailHeader
        ? ``
        : css`
            flex-wrap: wrap;
          `}
  }
`;

const Button = styled.button<{ isBlockDetailHeader: boolean }>`
  width: 200px;
  height: 48px;
  border-radius: 50px;
  font-size: ${FONT_SIZE.M}px;
  font-weight: ${FONT_WEIGHT.BOLD};
  color: ${COLOR.GRAY50.code};
  background-color: ${COLOR.GRAY900.code};

  ${mq.sp} {
    font-size: ${FONT_SIZE.S}px;
    height: 40px;
    ${({ isBlockDetailHeader }) =>
      isBlockDetailHeader
        ? css`
            width: 100%;
            max-width: 160px;
            min-width: 136px;
          `
        : css`
            flex-wrap: wrap;
            width: 240px;
            margin-right: 0px;
            margin-bottom: 16px;
          `}
  }
`;
export const SettingAccessButton = styled(Button)`
  margin-right: 16px;
`;

export const TopAccessButton = styled(Button)``;
